import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import {
  LoadingController,
  AlertController,
  MenuController,
  PopoverController,
} from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FirebaseService } from '../services/firebase.service';
import { AuthService } from '../services/auth.service';
import { ProfileService } from '../services/profile.service';
import { AppComponent } from '../app.component';
import { Observable } from 'rxjs';
import { CustomerdatabaseService } from '../services/customerdatabase.service';
import { ApplicantService } from '../services/applicant-service.service';
import { JobOfferService } from '../services/jobOfferService.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslationObject } from '../helper/TranslationObject';
import { translations } from '../helper/translations';
import { Languages } from '../helper/Languages';
import { MenuService } from '../services/menu-service';
import { Constants } from '../helper/Constants';
import { DisclaimerPopoverComponent } from '../components/disclaimer-popover/disclaimer-popover.component';
import { NetworkService } from '../services/network.service';
import { disclaimerHTML } from './disclaimer';
import { EventsService } from '../services/tracking/events.service';
import { MicrosoftService } from '../services/microsoft.service';
import { cfRegionLinks } from '../helper/cfRegionLinks';

interface PostObject {
  response?: String;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit, AfterViewInit {
  public loginForm: FormGroup;
  public loading: HTMLIonLoadingElement;
  coolClctn$: Observable<any>;
  perfectClctn$: Observable<any>;
  daysBetweenDates = [];
  scheduleimg = '../assets/icon/schedule.png';
  ipPt = environment.server;

  login_img = '../../assets/login-logo.jpg';
  logo_img = '../../assets/logo_schwarz_neu.png';
  img_finish = false;

  translationObject: TranslationObject;

  browserLang: string;

  genCustomToken = cfRegionLinks.genCustomToken;
  loginPlatform = cfRegionLinks.loginPlatform;

  constructor(
    public loadingCtrl: LoadingController,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private alertCtrl: AlertController,
    public profileService: ProfileService,
    private popoverController: PopoverController,
    private authService: AuthService,
    private appComponent: AppComponent,
    private menuCtrl: MenuController,
    private customerDB: CustomerdatabaseService,
    private applicantService: ApplicantService,
    private jobOfferService: JobOfferService,
    private translateService: TranslateService,
    private menuService: MenuService,
    private http: HttpClient,
    private firebaseService: FirebaseService,
    private network: NetworkService,
    private eventsService: EventsService,
    private activatedRoute: ActivatedRoute,
    private microsoftService: MicrosoftService,
  ) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      stayLoggedIn: [false],
    });

    this.translationObject = TranslationObject.TRANSLATION_OBJECT;

    this.browserLang = navigator.language.slice(0, 2);
    translateService.addLangs([
      'deutsch',
      'englisch',
      'französisch',
      'italienisch',
    ]);
  }

  async ngOnInit() {
    this.checkFromRedirect();
    this.network.getIpAdress();
  }

  async ngAfterViewInit() {
    document
      .querySelector('#password')
      .addEventListener('keypress', function (e) {
        this.event = e;
        if (this.event.key == 'Enter') {
          document.getElementById('login').click();
        }
      });
    this.autoLoginWithToken();
  }

  async loadApplicants() {
    let allApplicants = [];
    let allApplicantsObject;
    try {
      allApplicantsObject = await this.customerDB.getApplicantsWithCreatedFromAPI();
    } catch (error) {
      console.error(error);
    }
    if (allApplicantsObject && allApplicantsObject.data) {
      allApplicants = allApplicantsObject.data;
    }
    console.log('allApplicants', allApplicants);
    this.applicantService.getAllApplicants(allApplicants);
  }

  async autoLoginWithToken() {
    let token = this.getCookie('MONAPlatformToken');
    console.log('autoLogin');
    if (token != undefined && token != null) {
      this.loading = await this.loadingCtrl.create();
      await this.loading.present();
      let body = {
        endpoint: 'retreiveSessionData',
        sessionCookie: token,
      };
      try {
        this.http.post(this.genCustomToken, body, {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          }
        }).subscribe(
          async (data: any) => {
            console.log("data", data);
            if (data.companyData != undefined && data.sessionData) {
              this.authService.verifySessionCookie(true);
              // let company = data.companyData[0]; TODO
              let sessionData = data.sessionData;
              const uid = sessionData.uid;
              this.authService.saveUserId(uid);
              this.authService.saveAccountId(data.uid);

              this.eventsService.setUserId(uid);
              this.customerDB.setUserStorage(uid);
              let userEmail = sessionData.email;
              if (userEmail.includes('@mona-ai.de')) {
                this.authService.saveUserRole('admin');
              } else {
                this.authService.saveUserRole('user');
              }
              this.authService.saveUserId(uid);
              this.authService.saveEmail(userEmail);
                
                // Generate/fetch API key for this session
                try {
                  const apiKey = await this.customerDB.getApiKey();
                  this.authService.saveApiKey(apiKey);
                  console.log('API key saved to auth service for session');
                } catch (error) {
                  console.error('Failed to generate API key during auto-login:', error);
                  // Continue with login flow even if API key generation fails
                }
                
                let sendObject = {
                  uid: uid,
                  email: userEmail,
                  ip: this.network.returnIpAdress(),
                  userAgent: this.network.returnUserAgent(),
                  language: this.network.returnUserLanguage(),
                };
              this.http
                .post(this.loginPlatform,
                  sendObject,
                  {
                    headers: {
                      'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin': '*',
                    },
                  },
                )
                .subscribe(async (data: any) => {
                  console.log('data', data);
                  if (data.code === 4002) {
                    // go to pricing
                    this.loading.dismiss();
                    this.router.navigateByUrl('pricing');
                    return;
                  }
                  if (data.database != undefined && data.kundennummer != 0) {
                    try {
                      // 1) Connect to DB
                      const snap = await this.customerDB.connectDB(data);

                      if (snap === true) {
                        // 2) Fetch initial data
                        // const allApplicants = await this.customerDB.getApplicantsWithCreated();
                        // const snapshotApplicantObservable = await this.customerDB.getApplicantsWithCreated();this
                        await this.loadApplicants();
                        const jobOffersProcessed = await this.customerDB.getJobOffersProcessed();
                        // 3) Parallel fetch for job offers and applicants
                        // const [jobOffersProcessed, allApplicants] = await Promise.all([
                        //   this.customerDB.getJobOffersProcessed(),
                        //   this.applicantService.getAllApplicants(snapshotApplicantObservable)
                        // ]);

                        // 4) Set job offers
                        this.jobOfferService.allJobOffers = [];
                        this.jobOfferService.jobOffers = [];
                        this.jobOfferService.allJobOffers = jobOffersProcessed;
                        this.jobOfferService.jobOffers = jobOffersProcessed;

                        // 5) Set authentication and plan info
                        const customerNumber = this.customerDB.getCustomerNumber();
                        this.authService.saveKundennummer(customerNumber);
                        this.authService.saveAccountId(data.account_id);
                        this.authService.saveLicenses(data.licenses);

                        let currentPlan = '';
                        const butterfly = data.butterfly || false;
                        if (!butterfly) {
                          this.customerDB.setcurrentPlan('enterprise');
                          currentPlan = 'enterprise';
                        } else {
                          currentPlan =
                            await this.firebaseService.retreiveUserPlan(
                              userEmail,
                            );
                          this.customerDB.setcurrentPlan(currentPlan);
                        }

                        // 6) Handle disclaimers
                        console.log('userEmail', userEmail);
                        const seenDisclaimer = this.customerDB.returnSeenDisclaimerStatus();
                        const confirmedDisclaimer =
                          this.customerDB.returnConfirmedDisclaimerStatus();
                        if (confirmedDisclaimer === false) {
                          // this.presentDisclaimer(this.customerDB.returnUserId());
                        }

                        // 7) Translate, dismiss loading spinner
                        this.translatePlatform();
                        this.loading.dismiss();

                        // 8) Navigate based on currentPlan
                        if (
                          currentPlan === 'free' ||
                          currentPlan === 'pro' ||
                          currentPlan === 'professional'
                        ) {
                          this.menuService.setMenuForRole(currentPlan);
                          this.router.navigateByUrl('mona-agent-chat');
                        } else if (currentPlan === 'enterprise') {
                          this.menuService.setMenuForRole('enterprise');
                          this.router.navigateByUrl('dashboard');
                        } else {
                          this.router.navigateByUrl('dashboard');
                        }

                        // 9) Retrieve team member status
                        const test = userEmail;
                        console.log('test', test);
                        try {
                          const teamMemberSnap = await this.customerDB
                            .retreiveTeammemberStatusByEmail()
                            .where('email', '==', test)
                            .get();
                          if (teamMemberSnap.empty) {
                            console.log('kein teammember mit rolle');
                          } else {
                            console.log('teamMemberSnap', teamMemberSnap);
                            const status =
                              teamMemberSnap.docs[0].data().status;
                            const location =
                              teamMemberSnap.docs[0].data().locationName;
                            if (status != null && status !== undefined) {
                              this.profileService.saveTeamMemberStatus(
                                status,
                              );
                              this.profileService.saveTeamMemberMandant(
                                location,
                              );
                              this.menuService.setUserRoleByRole(status);
                            } else {
                              console.log('kein teammember mit rolle');
                            }
                          }
                        } catch (err) {
                          console.error(
                            'Error retrieving team member status:',
                            err,
                          );
                        }

                        //10 save access token and refresh token if available
                        this.customerDB.setUserEmail(userEmail);
                        this.microsoftService.checkForTokensMicrosoft();
                      } else {
                        // If snap !== true
                        this.presentError(
                          'Fehler beim Laden der Datenbank. Bitte versuchen Sie es später erneut.',
                        );
                        this.loading.dismiss();
                      }
                    } catch (error) {
                      // Catch any unforeseen errors
                      console.error('Unexpected error:', error);
                      this.presentError(
                        'Ein unerwarteter Fehler ist aufgetreten.',
                      );
                      this.loading.dismiss();
                    }

                    // this.customerDB.connectDB(data).then(async (snap) => {
                    //   if (snap == true) {
                    //     const snapshotApplicantObservable = await this.customerDB.getApplicantsWithCreated();
                    //     Promise.all([await this.customerDB.getJobOffersProcessed(), this.applicantService.getAllApplicants(snapshotApplicantObservable)]).then(
                    //       async ([result1, result2]) => {
                    //         this.jobOfferService.allJobOffers = [];
                    //         this.jobOfferService.jobOffers = [];
                    //         this.jobOfferService.allJobOffers = result1;
                    //         this.jobOfferService.jobOffers = result1;
                    //         let customerNumber = this.customerDB.getCustomerNumber();
                    //         this.authService.saveKundennummer(customerNumber);
                    //         this.authService.saveAccountId(data.account_id);
                    //         this.authService.saveLicenses(data.licenses);
                    //         let currentPlan = "";
                    //         let butterfly = data.butterfly || false;
                    //         if (!butterfly) {
                    //           this.customerDB.setcurrentPlan("enterprise")
                    //           currentPlan = "enterprise";
                    //         } else {
                    //           currentPlan = await this.firebaseService.retreiveUserPlan(userEmail)
                    //           this.customerDB.setcurrentPlan(currentPlan);
                    //         }
                    //         console.log("userEmail", userEmail);
                    //         let seenDisclaimer = this.customerDB.returnSeenDisclaimerStatus();
                    //         let confirmedDisclaimer = this.customerDB.returnConfirmedDisclaimerStatus();
                    //         if (confirmedDisclaimer == false) {
                    //           this.presentDisclaimer(this.customerDB.returnUserId()); // TODO
                    //         }
                    //         this.translatePlatform();
                    //         this.loading.dismiss();
                    //         if (
                    //           currentPlan == "free" || currentPlan == "pro" || currentPlan == "professional"
                    //         ) {
                    //           this.menuService.setMenuForRole(currentPlan);
                    //           this.router.navigateByUrl('mona-agent-chat');
                    //         } else if (currentPlan == "enterprise") {
                    //           this.menuService.setMenuForRole("enterprise");
                    //           this.router.navigateByUrl('dashboard');
                    //         } else {
                    //           this.router.navigateByUrl('dashboard');
                    //         }

                    //         // let test = "Isra.Iseini@proserv-dl.de";
                    //         // let test = "Matteo.Scaduto@proserv-dl.de";
                    //         // let test = "Katrin.Panther@proserv-dl.de";
                    //         // let test = "juergen.spinner@proserv-dl.de";
                    //         let test = userEmail;
                    //         this.customerDB.retreiveTeammemberStatusByEmail()
                    //           .where("email", "==", test)
                    //           .get().then((snap) => {
                    //             console.log("snap", snap);
                    //             let status = snap.docs[0].data().status;
                    //             let location = snap.docs[0].data().locationName;
                    //             if (status != null && status != undefined) {
                    //               this.profileService.saveTeamMemberStatus(status);
                    //               this.profileService.saveTeamMemberMandant(location);
                    //               this.menuService.setUserRoleByRole(status);
                    //             }
                    //           }).catch((err) => {
                    //             console.log("err", err);
                    //           })

                    //       });
                    //   } else {
                    //     this.presentError("Fehler beim Laden der Datenbank. Bitte versuchen Sie es später erneut.")
                    //     this.loading.dismiss();
                    //   }
                    // });
                  } else if (
                    data.kundennummer == 0 &&
                    data.emailVerified == true
                  ) {
                    this.loadInfo();
                    this.loading.dismiss();
                  } else if (
                    data.kundennummer == 0 &&
                    data.emailVerified == false
                  ) {
                    this.presentError(
                      'Your account is not activated yet. Please check your email for the activation link.',
                    );
                    this.loading.dismiss();
                  } else {
                    this.presentError(
                      'Error connecting to the database. Please try again later.',
                    );
                    this.loading.dismiss();
                  }
                });
            } else {
              this.loading.dismiss();
              this.presentError(
                'Error connecting to the database. Please reach out to support.',
              );
            }
          },
          (err) => {
            console.log('err', err);
            this.loading.dismiss();
          },
        );
      } catch (err) {
        console.log('err', err);
      }
      return;
    }
    this.appComponent.showGlobalBar = "false";
  }

  async ionViewWillEnter() {
    localStorage.clear();
    if (this.authService.isLoggedIn()) {
      // if user is already logged in, and comes back to login page, then log him out
      await this.authService.logOut();
    }
    this.menuCtrl.enable(false);
  }

  /**
   * change the image opacity after the image is done loading.
   * @param event the event fired from IonImgDidLoad
   */
  imgIsFinished(event) {
    event.target.setAttribute('style', 'opacity: 1;');
  }

  /**
   * Function to Convert language code to string
   * @returns language name as string
   */
  findLanguageName() {
    let lang;
    let languages = new Languages().LANGUAGES;
    for (let languageObj of languages) {
      if (languageObj.isoCode == this.browserLang) {
        lang = languageObj.language;
      } else {
        lang = 'deutsch';
      }
    }
    return lang;
  }

  async getPlatformLanguage() {
    let language = 'deutsch';
    await this.customerDB
      .getProfile()
      .get()
      .then((snap) => {
        if (snap) {
          const docs = snap.docs;
          if (docs && docs.length > 0) {
            const data = docs[0].data();
            if (data) {
              const platformLanguage = data.platformLanguage;
              if (platformLanguage) {
                language = platformLanguage.language.toLowerCase();
                localStorage.setItem('platformLanguage', language);
              } else {
                language = this.findLanguageName();
                localStorage.setItem('platformLanguage', language);
              }
            } else {
              language = 'deutsch';
              localStorage.setItem('platformLanguage', language);
            }
          }
        }
      });
    return language;
  }

  _initialiseTranslation(): void {
    translations.forEach((obj) => {
      this.translateService.get(obj).subscribe((res: string) => {
        this.translationObject[obj] = res;
        Constants[obj] = res;
      });
    });
  }

  async translatePlatform() {
    let language = await this.getPlatformLanguage();
    this.translateService.use(language);
    this._initialiseTranslation();
  }

  async presentDisclaimer(uid) {
    const popover = await this.popoverController.create({
      component: DisclaimerPopoverComponent,
      cssClass: 'disclaimer-popover', // Optional: for additional styling
      translucent: true,
    });

    popover.onDidDismiss().then((data) => {
      console.log('data', data);
      if (data.data) {
        if (data.data.confirmed) {
          this.customerDB.confirmedAIDisclaimer(uid);
        } else {
          this.customerDB.saveAIDisclaimer(uid, disclaimerHTML);
        }
      } else {
        this.customerDB.saveAIDisclaimer(uid, disclaimerHTML);
      }
    });
    await popover.present();
  }

  private getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() || null;
    }
    return null;
  }

  setCookie(name: string, value: string, days: number): void {
    const expirationDate = new Date();
    expirationDate.setTime(
      expirationDate.getTime() + days * 24 * 60 * 60 * 1000,
    );
    document.cookie = `${name}=${value}; path=/; expires=${expirationDate.toUTCString()}; Secure; SameSite=Strict`;
  }

  async login(): Promise<void> {
    if (!this.loginForm.valid) {
    } else {
      this.loading = await this.loadingCtrl.create();
      await this.loading.present();
      const email = this.loginForm.value.email;
      const password = this.loginForm.value.password;
      this.appComponent.loginFinished = true;
      this.authService.loginUser(email, password).then(
        async (snap: any) => {
          if (snap.user.email) {
            let body = {
              idToken: snap.user.ya,
              endpoint: "getsessionCookie"
            }
            this.http.post(this.genCustomToken, body, {
              headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
              }
            }).subscribe((data: any) => {
              // Only set cookie if user wants to stay logged in
              if (this.loginForm.value.stayLoggedIn) {
                this.setCookie('MONAPlatformToken', data.sessionCookie, 14); // 14 days expiry
              }
            })


            this.customerDB.setUserStorage(snap.user.uid);

            let userEmail = snap.user.email;
            if (userEmail.includes('@mona-ai.de')) {
              this.authService.saveUserRole('admin');
            } else {
              this.authService.saveUserRole('user');
            }

            this.authService.saveUserId(snap.user.uid);
            this.authService.saveEmail(userEmail);
            
            // Generate/fetch API key for this session
            try {
              const apiKey = await this.customerDB.getApiKey();
              this.authService.saveApiKey(apiKey);
              console.log('API key saved to auth service for session');
            } catch (error) {
              console.error('Failed to generate API key during login:', error);
              // Continue with login flow even if API key generation fails
            }
            
            const TempSnap = snap;
            let sendObject = {
              uid: snap.user.uid,
              email: snap.user.email,
              ip: this.network.returnIpAdress(),
              userAgent: this.network.returnUserAgent(),
              language: this.network.returnUserLanguage()
            }
            this.http.post(this.loginPlatform, sendObject, {
              headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
              },
            }).subscribe((data: any) => {
              console.log("data", data);
              if (data.signedUpCustomer === true) {
                // go to pricing
                this.router.navigateByUrl('pricing');
                return;
              }
              if (data.database != undefined && data.kundennummer != 0) {
                this.customerDB.connectDB(data).then(async (snap) => {
                  console.log(snap);
                  if (snap == true) {
                    const userExists = await this.customerDB.checkIfUsersExists(TempSnap.user.uid);
                    console.log("userExists, userExists", userExists)
                    if (userExists === false) {
                      this.customerDB.createuserInsideUsers(
                        TempSnap.user.uid,
                      );
                    } else {
                      //do nothing
                    }// const snapshotApplicantObservable = await this.customerDB.getApplicantsWithCreated();
                    // let allApplicants = await this.customerDB.getApplicantsWithCreatedFromAPI();
                    // let allApplicants = [];
                    // let allApplicantsObject;
                    // try {
                    //   allApplicantsObject = await this.customerDB.getApplicantsWithCreatedFromAPI();
                    // }
                    // catch (error) {}
                    // if(allApplicantsObject && allApplicantsObject.data) {
                    //   allApplicants = allApplicantsObject.data || [];
                    // }
                    // this.applicantService.getAllApplicants(allApplicants);
                    await this.loadApplicants();
                    const jobOffersProcessed = await this.customerDB.getJobOffersProcessed();
                    this.jobOfferService.allJobOffers = jobOffersProcessed || [];
                    this.jobOfferService.jobOffers = jobOffersProcessed || [];
                    let customerNumber = this.customerDB.getCustomerNumber();
                    this.authService.saveKundennummer(customerNumber);
                    this.authService.saveAccountId(data.account_id);
                    this.authService.saveLicenses(data.licenses);
                    let currentPlan = '';
                    let butterfly = data.butterfly || false;
                    console.log('butterfly', butterfly);
                    if (!butterfly) {
                      this.customerDB.setcurrentPlan('enterprise');
                      currentPlan = 'enterprise';
                    } else {
                      currentPlan =
                        await this.firebaseService.retreiveUserPlan(
                          userEmail,
                        );
                      this.customerDB.setcurrentPlan(currentPlan);
                    }
                    let seenDisclaimer =
                      this.customerDB.returnSeenDisclaimerStatus();
                    let confirmedDisclaimer =
                      this.customerDB.returnConfirmedDisclaimerStatus();
                    console.log('seenDisclaimer', seenDisclaimer);
                    console.log(
                      'confirmedDisclaimer',
                      confirmedDisclaimer,
                    );
                    if (confirmedDisclaimer == false) {
                      //  this.presentDisclaimer(this.customerDB.returnUserId()); // TODO
                    }
                    this.translatePlatform();
                    this.loading.dismiss();
                    // this.router.navigateByUrl('dashboard');
                    // TODO
                    console.log('login currentPlan', currentPlan);
                    if (
                      currentPlan == 'free' ||
                      currentPlan == 'pro' ||
                      currentPlan == 'professional'
                    ) {
                      this.menuService.setMenuForRole(currentPlan);
                      this.router.navigateByUrl('mona-agent-chat');
                    } else if (
                      this.customerDB.returnCurrentPlan() == 'enterprise'
                    ) {
                      this.menuService.setMenuForRole('enterprise');
                      this.router
                        .navigateByUrl('dashboard')
                        .then((success) => {
                          if (success) {
                            console.log(
                              'Navigation to dashboard successful!',
                            );
                          } else {
                            console.log(
                              'Navigation to dashboard failed.',
                            );
                          }
                        })
                        .catch((error) => {
                          console.error(
                            'Error navigating to dashboard:',
                            error,
                          );
                        });
                    } else {
                      this.router.navigateByUrl('dashboard');
                    }
                    let test = userEmail;
                    this.customerDB
                      .retreiveTeammemberStatusByEmail()
                      .where('email', '==', test)
                      .get()
                      .then((snap) => {
                        console.log('snap', snap);
                        let status = snap.docs[0].data().status;
                        let location = snap.docs[0].data().locationName;
                        if (status != null && status != undefined) {
                          this.profileService.saveTeamMemberStatus(
                            status,
                          );
                          this.profileService.saveTeamMemberMandant(
                            location,
                          );
                          this.menuService.setUserRoleByRole(status);
                        } else {
                          console.log('kein teammember mit rolle');
                        }
                      })
                      .catch((err) => {
                        console.log('err', err);
                      });

                  } else {
                    this.presentError(
                      'Fehler beim Laden der Datenbank. Bitte versuchen Sie es später erneut.',
                    );
                    this.loading.dismiss();
                  }
                });
              } else if (
                data.kundennummer == 0 &&
                data.emailVerified == true
              ) {
                this.loadInfo();
                this.loading.dismiss();
              } else if (
                data.kundennummer == 0 &&
                data.emailVerified == false
              ) {
                this.presentError(
                  'Your account is not activated yet. Please check your email for the activation link.',
                );
                this.loading.dismiss();
              } else {
                this.presentError(
                  'Error connecting to the database. Please reach out to support.',
                );
                this.loading.dismiss();
              }
            },
              (error) => {
                console.log('error', error);
                this.loading.dismiss();
                this.presentError(
                  'Error connecting to the database. Please reach out to support.',
                );
              },
            );
          } else {
            this.customerDB.isPremium = false;
            this.router.navigateByUrl('dashboard');
          }
        },
        (error) => {
          console.log('error', error);
          this.loading.dismiss().then(async () => {
            this.http.post(this.loginPlatform, {
              email: email || "",
              ip: this.network.returnIpAdress(),
              userAgent: this.network.returnUserAgent(),
              language: this.network.returnUserLanguage(),
              error: error
            }, {
              headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
              },
            }).subscribe((data: any) => { })
            const alert = await this.alertCtrl.create({
              message: error.message,
              buttons: [{ text: 'Ok', role: 'cancel' }],
            });
            await alert.present();
          });
        },
      );
    }
  }

  async loadInfo() {
    this.router.navigateByUrl('pricing');
  }

  register() {
    this.router.navigateByUrl('signup');
  }

  async presentError(message) {
    const alert = await this.alertCtrl.create({
      header: 'Fehler',
      message: message,
      buttons: ['OK'],
    });

    await alert.present();
  }

  googleLogin() { }

  async navigateToForgotPassword() {
    const alert = await this.alertCtrl.create({
      header: 'Passwort zurücksetzen',
      message:
        'Bitte gib deine E-Mail-Adresse ein, um einen Link zum Zurücksetzen des Passworts zu erhalten.',
      inputs: [
        {
          name: 'email',
          type: 'email',
          placeholder: 'E-Mail-Adresse',
        },
      ],
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
        },
        {
          text: 'Passwort zurücksetzen',
          handler: (data) => {
            if (data.email) {
              this.resetPassword(data.email);
            } else {
              this.showError('Bitte eine gültige E-Mail-Adresse eingeben.');
            }
          },
        },
      ],
    });

    await alert.present();
  }

  async resetPassword(email: string) {
    console.log('Passwort zurücksetzen für:', email);

    try {
      await this.authService.resetPassword(email);
      this.showSuccess('Falls die E-Mail existiert, wurde ein Link gesendet.');
    } catch (error) {
      console.error('Fehler beim Zurücksetzen des Passworts:', error);
      let errorMessage =
        'Fehler beim Zurücksetzen des Passworts. Bitte versuche es später erneut.';
      if (error.code === 'auth/invalid-email') {
        errorMessage = 'Bitte gib eine gültige E-Mail-Adresse ein.';
      } else if (error.code === 'auth/user-not-found') {
        errorMessage = 'Es existiert kein Benutzer mit dieser E-Mail-Adresse.';
      }
      this.showError(errorMessage);
    }
  }

  async showError(message: string) {
    const alert = await this.alertCtrl.create({
      header: 'Fehler',
      message,
      buttons: ['OK'],
    });
    await alert.present();
  }

  async showSuccess(message: string) {
    const alert = await this.alertCtrl.create({
      header: 'Erfolg',
      message,
      buttons: ['OK'],
    });
    await alert.present();
  }
  /**
   * check if we have code from microsoft login redirect
   * @returns
   */
  checkFromRedirect() {
    let code = this.activatedRoute.snapshot.queryParams.code;
    if (!code) return;
    let state = this.activatedRoute.snapshot.queryParams.state;
    if (!state) return;
    this.microsoftService.updateMicrosoftTokens(code, state);
  }

  async loginWithSaml() {
    const result = await this.authService.signInWithSaml();
    console.log('SAML Provider:', result);
  }
}
